import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NeveBaseComponent } from './base/neve-base.component';
import { ValmetDnaService } from './valmet-dna.service';
@NgModule({
  declarations: [ NeveBaseComponent ],
  imports: [ CommonModule ],
  exports: [ NeveBaseComponent ],
  providers: [ ValmetDnaService ]
})
export class NeveModule {

}
